import { useForm } from 'react-hook-form'
import { companySchema } from '../../utils/entities'
import { CompanyType } from '../../utils/types'
import { zodResolver } from '@hookform/resolvers/zod'
import { useTaxID } from '../useTaxID'

export const useCompanyForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setValue,
    getValues,
    setError,
    watch,
  } = useForm<CompanyType>({ resolver: zodResolver(companySchema) })
  const { validateTaxID } = useTaxID()

  const validateAdditionalData = (data: CompanyType) => {
    let isValid = true

    if (data.cnpj && !validateTaxID(data.cnpj)) {
      setError('cnpj', {
        type: 'validate',
        message: 'CNPJ inválido',
      })

      isValid = false
    }

    return isValid
  }

  const onSubmit = (callback: (data: CompanyType) => void) => {
    return handleSubmit((data) => {
      if (!validateAdditionalData(data)) return

      callback(data)
    })
  }

  return {
    register,
    handleSubmit: onSubmit,
    errors,
    clearErrors,
    setValue,
    getValues,
    setError,
    watch,
  }
}
